import React from 'react';
import { SEOHelmet } from 'components/SEO';
import { PlayLayout } from '../../layout/PlayLayout';
import { PlayAuthCard } from '../../components/PlayAuthCard';

/**
 * Signed-out /play/host (Eric's ruling 31, 2026-10-30): the same Play auth
 * card as the invite page instead of the regular login, returning to
 * /play/host after either entry.
 */
const HostSignInPage: React.FC = () => (
  <PlayLayout title="Host a tournament" backTo="/play">
    <SEOHelmet title="Host a tournament - TradeMagic Play" description="Sign in to host a tournament on TradeMagic Play." noindex />
    <PlayAuthCard returnTo="/play/host" title="Sign in to host" footnote="No address or phone number needed to host." />
  </PlayLayout>
);

export default HostSignInPage;
